import styled from 'styled-components';

export const PropertiesAttributesListWrap = styled.div`
    display: block;
    width: 100%;
    overflow: auto;
`;
